import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "./BinderSwitcher.css";

const languageLabel = language => ({ es: "Español", en: "Inglés", jp: "Japonés", ja: "Japonés" }[language] || language || "");
const searchable = value => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export default function BinderSwitcher({ collections, activeId, totalOwned, sets = [], onSelect, onCreate, renderSetImage }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const active = collections.find(collection => collection.id === activeId);
  const catalogFor = collection => {
    const catalog = sets.find(set => set.id === collection.card_set_id);
    if (!catalog && !collection.set_logo_url && !collection.set_symbol_url) return null;
    return { ...catalog, id: collection.card_set_id, logo_url: catalog?.logo_url || collection.set_logo_url, symbol_url: catalog?.symbol_url || collection.set_symbol_url };
  };
  const visible = collections.filter(collection => searchable([
    collection.name, collection.set_name, collection.theme_query, languageLabel(collection.set_language),
    catalogFor(collection)?.code
  ].filter(Boolean).join(" ")).includes(searchable(search.trim())));
  const pick = id => { onSelect(id); setOpen(false); setSearch(""); };
  const image = collection => {
    const set = catalogFor(collection);
    return set && renderSetImage ? renderSetImage(set) : <i aria-hidden="true" className="bi bi-journal-album" />;
  };

  return <>
    <div className="binder-switcher-row">
      <button type="button" className="binder-switcher-trigger" onClick={() => { setSearch(""); setOpen(true); }} aria-label={`Cambiar binder: ${active?.name || "Todos los binders"}`} aria-haspopup="dialog" aria-expanded={open}>
        <span className="binder-switcher-logo">{active ? image(active) : <i aria-hidden="true" className="bi bi-collection" />}</span>
        <span className="binder-switcher-copy"><small>Mis binders · {collections.length}</small><strong>{active?.name || "Todos los binders"}</strong></span>
        <i aria-hidden="true" className="bi bi-chevron-down" />
      </button>
      <Button className="btn-cardora binder-create-quick" onClick={onCreate} aria-label="Crear binder" title="Crear binder"><i aria-hidden="true" className="bi bi-plus-lg" /></Button>
    </div>
    <Modal show={open} onHide={() => setOpen(false)} centered scrollable contentClassName="binder-switcher-modal">
      <Modal.Header closeButton><Modal.Title>Mis binders</Modal.Title></Modal.Header>
      <Modal.Body>
        <Form.Group controlId="binder-switcher-search" className="binder-switcher-search">
          <Form.Label className="visually-hidden">Buscar binder</Form.Label>
          <i aria-hidden="true" className="bi bi-search" />
          <Form.Control autoFocus value={search} onChange={event => setSearch(event.target.value)} placeholder="Buscar por nombre, set o idioma" autoComplete="off" />
          {search && <button type="button" aria-label="Limpiar búsqueda de binders" onClick={() => setSearch("")}><i aria-hidden="true" className="bi bi-x-lg" /></button>}
        </Form.Group>
        <div className="binder-switcher-options">
          {!search.trim() && <button type="button" className={`binder-switcher-option ${activeId === "all" ? "is-selected" : ""}`} aria-pressed={activeId === "all"} onClick={() => pick("all")}>
            <span className="binder-switcher-logo"><i aria-hidden="true" className="bi bi-collection" /></span>
            <span><strong>Todos los binders</strong><small>{totalOwned} cartas propias</small></span>
            <i aria-hidden="true" className={`bi ${activeId === "all" ? "bi-check-circle-fill" : "bi-chevron-right"}`} />
          </button>}
          {visible.map(collection => {
            const set = catalogFor(collection);
            const isSet = Boolean(collection.card_set_id);
            const target = Number(collection.target_total || set?.official_cards || set?.total_cards || 0);
            const owned = Number(collection.owned_count ?? collection.cards_count ?? 0);
            const selected = activeId === collection.id;
            return <button type="button" key={collection.id} className={`binder-switcher-option ${selected ? "is-selected" : ""}`} aria-pressed={selected} onClick={() => pick(collection.id)}>
              <span className="binder-switcher-logo">{image(collection)}</span>
              <span><strong>{collection.name}</strong><small>{[languageLabel(collection.set_language || set?.language), isSet ? "Por set" : collection.theme_query ? collection.theme_query : "Personalizado", `${owned} cartas propias`].filter(Boolean).join(" · ")}</small>
                {isSet && target > 0 && <span className="binder-switcher-progress" aria-label={`${owned} de ${target} cartas`}><span style={{ width: Math.min(100, Math.round(owned / target * 100)) + "%" }} /></span>}
              </span>
              <i aria-hidden="true" className={`bi ${selected ? "bi-check-circle-fill" : "bi-chevron-right"}`} />
            </button>;
          })}
        </div>
        {!visible.length && <p className="binder-switcher-empty">{search.trim() ? "No encontramos binders con esa búsqueda." : "Crea tu primer binder para empezar."}</p>}
      </Modal.Body>
      <Modal.Footer><Button className="btn-cardora" onClick={() => { setOpen(false); onCreate(); }}><i aria-hidden="true" className="bi bi-plus-lg me-2" />Crear binder</Button></Modal.Footer>
    </Modal>
  </>;
}
